var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank-page container1 d-flex flex-column h-100"},[_c('Navigation'),_c('div',{staticClass:"app-content content flex-shrink-0"},[_c('div',{staticClass:"content-wrapper"},[(_vm.authenticated)?_c('div',{staticClass:"content-body"},[_c('router-view')],1):_vm._e()])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }